import { exists } from "../utils/Safe";
import { fail } from "../utils/Assert";
import FlumpLibrary from "./FlumpLibrary";

/**
 * Flump manager. Handles storing Flump libraries for use in games.
 */
export default class Flump
{
    constructor()
    {
        /**
         * Map of useable Flump libraries.
         * @type {Object.<string, FlumpLibrary>}
         */
        this.libraries = { }
    }
    
    /**
     * Cleans up Flump properties.
     */
    destroy()
    {
        let keys = Object.keys(this.libraries);
        while (keys.length > 0)
        {
            this.removeLibrary(keys.shift());
        }
    }
    
    /**
     * Adds a useable library to Flump.
     * @param {Phaser.Game} game - Reference to the active Phaser.Game object.
     * @param {string} key - Accessor key. This is the same key used in the manifest.
     * @param {string} atlasUrl - Url where the atlas files are located.
     */
    addLibrary(game, key, atlasUrl)
    {
        if (exists(this.libraries[key]))
        {
            fail(`[Flump] Library with ${key} already exists. Be careful of memory leaks.`);
            
        }
        else
        {
            this.libraries[key] = new FlumpLibrary(game, game.cache.getJSON(key), atlasUrl);
        }
    }

    /**
     * Removes a useable library from Flump
     * @param {string} key - Accessor key
     */
    removeLibrary(key)
    {
        if (exists(this.libraries[key]))
        {
            this.libraries[key].destroy();
            delete this.libraries[key];
        }
    }
}